import { FileText } from 'lucide-react';
import TextWithClickableQuotes from '@/utils/TextWithClickableQuotes';
import { formatSummaryForClipboard } from '@/utils/formatForClipboard';
import AnalysisSection from '@/components/analysis/AnalysisSection';
import { resolveTranslation } from '@/utils/resolveTranslation';
import {
  translateSummary,
  translateNoSummaryData,
} from '@/pages/projects/single-project/Content/project_results/resultsPageTranslations';

interface StoryZoneProps {
  summary?: string;
  isLoading: boolean;
  analysisLanguage: string;
  voiceQuotes?: Array<{ conversation_id: string; message_id?: string }>;
  fallbackQuestionId?: string;
}

function StoryZone({
  summary,
  isLoading,
  analysisLanguage,
  voiceQuotes,
  fallbackQuestionId,
}: StoryZoneProps) {
  const hasSummary = !!summary?.length;

  return (
    <div className="flex flex-col gap-5">
      {/* Summary — styled like other analysis sections */}
      <AnalysisSection
        title={resolveTranslation(translateSummary, analysisLanguage)}
        icon={<FileText className="h-5 w-5 text-primary" />}
        variant="highlight"
        defaultOpen
        isLoading={isLoading}
        hasData={hasSummary}
        noDataText={resolveTranslation(translateNoSummaryData, analysisLanguage)}
        copyText={hasSummary ? formatSummaryForClipboard(summary!) : undefined}
      >
        <div className="text-[15px] leading-relaxed text-neutral-700 overflow-hidden break-words">
          <TextWithClickableQuotes
            text={summary ?? ''}
            voiceQuotes={voiceQuotes}
            fallbackQuestionId={fallbackQuestionId}
          />
        </div>
      </AnalysisSection>
    </div>
  );
}

export default StoryZone;
